// removed by extract-text-webpack-plugin
module.exports = {"images-list":"ProductImages-module-images-list-15vL3","imagesList":"ProductImages-module-images-list-15vL3","small-thumnail":"ProductImages-module-small-thumnail-36MYc","smallThumnail":"ProductImages-module-small-thumnail-36MYc","active":"ProductImages-module-active-1Ugn1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/ProductImages/ProductImages.module.scss
// module id = 1206
// module chunks = 0